import { render, staticRenderFns } from "./notification-substitution.vue?vue&type=template&id=68781cbc&scoped=true&"
import script from "./notification-substitution.vue?vue&type=script&lang=js&"
export * from "./notification-substitution.vue?vue&type=script&lang=js&"
import style0 from "./notification-substitution.vue?vue&type=style&index=0&id=68781cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68781cbc",
  null
  
)

export default component.exports